import React, { useMemo } from 'react';
import { Box, Grid, TextField, MenuItem, Typography, FormHelperText } from '@mui/material';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const ESG_CATEGORIES = [
  { value: 'E', label: 'E - 환경 (Environmental)' },
  { value: 'S', label: 'S - 사회 (Social)' },
  { value: 'G', label: 'G - 지배구조 (Governance)' },
];

const QUILL_MODULES = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ align: [] }, { color: [] }, { background: [] }],
    ['link'],
    ['clean'],
  ],
};

const QUILL_FORMATS = [
  'header',
  'bold', 'italic', 'underline', 'strike',
  'list', 'bullet', 'indent',
  'align', 'color', 'background',
  'link',
];

const EsgForm = ({ formik }) => {
  const hasContentError = formik.touched.wrContent && Boolean(formik.errors.wrContent);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Grid container spacing={1}>
        <Grid item xs={9}>
          <TextField
            margin="normal"
            required
            variant="outlined"
            fullWidth
            id="wrTitle"
            name="wrTitle"
            label="제목"
            value={formik.values.wrTitle}
            onChange={formik.handleChange}
            error={formik.touched.wrTitle && Boolean(formik.errors.wrTitle)}
            helperText={formik.touched.wrTitle && formik.errors.wrTitle}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            margin="normal"
            select
            variant="outlined"
            fullWidth
            id="wrCategory"
            name="wrCategory"
            label="카테고리"
            value={formik.values.wrCategory}
            onChange={formik.handleChange}
          >
            <MenuItem value="">전체</MenuItem>
            {ESG_CATEGORIES.map((cat) => (
              <MenuItem key={cat.value} value={cat.value}>
                {cat.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="caption" color={hasContentError ? 'error' : 'text.secondary'} sx={{ ml: 0.5 }}>
            내용 *
          </Typography>
          <Box
            sx={{
              mt: 0.5,
              border: hasContentError ? '1px solid #d32f2f' : '1px solid rgba(0,0,0,0.23)',
              borderRadius: 1,
              '& .ql-container': { minHeight: 250, fontSize: '14px' },
              '& .ql-editor': { minHeight: 250 },
            }}
          >
            <ReactQuill
              theme="snow"
              modules={QUILL_MODULES}
              formats={QUILL_FORMATS}
              value={formik.values.wrContent}
              onChange={(value) => formik.setFieldValue('wrContent', value)}
              onBlur={() => formik.setFieldTouched('wrContent', true)}
              placeholder="내용을 입력하세요..."
            />
          </Box>
          {hasContentError && (
            <FormHelperText error sx={{ ml: 1.5 }}>
              {formik.errors.wrContent}
            </FormHelperText>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default EsgForm;
